import { render } from "./FanImages.vue?vue&type=template&id=8ae64600"
import script from "./FanImages.vue?vue&type=script&lang=js"
export * from "./FanImages.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__